// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ax-loader-primary: #17c1e8;
  --ax-loader-secondary: #141727;
  --ax-loader-text: #67748e;
}

.ax-loader {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(248, 249, 250, 0.72);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  /* Paint immediately: no fade-in, and its own GPU layer so the blur is ready
     on the first frame instead of 1–2s later. */
  will-change: backdrop-filter;
  transform: translateZ(0);
}

.ax-loader--inline {
  position: relative;
  inset: auto;
  z-index: auto;
  width: 100%;
  min-height: 200px;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.ax-loader__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.ax-loader__text {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ax-loader-text);
}

.ax-loader__dots i {
  font-style: normal;
  animation: ax-dot 1.4s infinite both;
}
.ax-loader__dots i:nth-child(2) { animation-delay: 0.2s; }
.ax-loader__dots i:nth-child(3) { animation-delay: 0.4s; }

/* Spinner */
.ax-spinner {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.ax-spinner__ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid rgba(23, 193, 232, 0.15);
  border-top-color: var(--ax-loader-primary);
  border-right-color: var(--ax-loader-primary);
  animation: ax-spin 0.9s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
}

.ax-spinner__ring--inner {
  inset: 22%;
  border-color: rgba(20, 23, 39, 0.1);
  border-bottom-color: var(--ax-loader-secondary);
  border-left-color: var(--ax-loader-secondary);
  animation-duration: 1.3s;
  animation-direction: reverse;
}

.ax-spinner__core {
  position: absolute;
  inset: 42%;
  border-radius: 50%;
  background: var(--ax-loader-primary);
  box-shadow: 0 0 12px rgba(23, 193, 232, 0.7);
  animation: ax-pulse 1.2s ease-in-out infinite;
}

/* Make the custom indicator sit correctly inside antd Spin / Table */
.ant-spin .ax-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.ant-spin-nested-loading > div > .ant-spin .ax-spinner {
  margin: 0 !important;
}

@keyframes ax-spin { to { transform: rotate(360deg); } }
@keyframes ax-pulse {
  0%, 100% { transform: scale(0.8); opacity: 0.7; }
  50% { transform: scale(1.15); opacity: 1; }
}
@keyframes ax-dot {
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
}
@keyframes ax-fade-in { from { opacity: 0; } to { opacity: 1; } }

@media (prefers-reduced-motion: reduce) {
  .ax-spinner__ring, .ax-spinner__core, .ax-loader__dots i { animation-duration: 3s; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Loader/Loader.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC;gDAC8C;EAC9C,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;AACA,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;;AAEzD,YAAY;AACZ;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C,qEAAqE;AACvE;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,+CAA+C;EAC/C,6CAA6C;EAC7C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,oBAAoB;AACtB;;AAEA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;AACvD;EACE,WAAW,qBAAqB,EAAE,YAAY,EAAE;EAChD,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;AACA;EACE,gBAAgB,UAAU,EAAE;EAC5B,MAAM,UAAU,EAAE;AACpB;AACA,wBAAwB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAEhE;EACE,2DAA2D,sBAAsB,EAAE;AACrF","sourcesContent":[":root {\n  --ax-loader-primary: #17c1e8;\n  --ax-loader-secondary: #141727;\n  --ax-loader-text: #67748e;\n}\n\n.ax-loader {\n  position: fixed;\n  inset: 0;\n  z-index: 2147483000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(248, 249, 250, 0.72);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  /* Paint immediately: no fade-in, and its own GPU layer so the blur is ready\n     on the first frame instead of 1–2s later. */\n  will-change: backdrop-filter;\n  transform: translateZ(0);\n}\n\n.ax-loader--inline {\n  position: relative;\n  inset: auto;\n  z-index: auto;\n  width: 100%;\n  min-height: 200px;\n  background: transparent;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n.ax-loader__content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.ax-loader__text {\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ax-loader-text);\n}\n\n.ax-loader__dots i {\n  font-style: normal;\n  animation: ax-dot 1.4s infinite both;\n}\n.ax-loader__dots i:nth-child(2) { animation-delay: 0.2s; }\n.ax-loader__dots i:nth-child(3) { animation-delay: 0.4s; }\n\n/* Spinner */\n.ax-spinner {\n  position: relative;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.ax-spinner__ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 3px solid rgba(23, 193, 232, 0.15);\n  border-top-color: var(--ax-loader-primary);\n  border-right-color: var(--ax-loader-primary);\n  animation: ax-spin 0.9s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;\n}\n\n.ax-spinner__ring--inner {\n  inset: 22%;\n  border-color: rgba(20, 23, 39, 0.1);\n  border-bottom-color: var(--ax-loader-secondary);\n  border-left-color: var(--ax-loader-secondary);\n  animation-duration: 1.3s;\n  animation-direction: reverse;\n}\n\n.ax-spinner__core {\n  position: absolute;\n  inset: 42%;\n  border-radius: 50%;\n  background: var(--ax-loader-primary);\n  box-shadow: 0 0 12px rgba(23, 193, 232, 0.7);\n  animation: ax-pulse 1.2s ease-in-out infinite;\n}\n\n/* Make the custom indicator sit correctly inside antd Spin / Table */\n.ant-spin .ax-spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.ant-spin-nested-loading > div > .ant-spin .ax-spinner {\n  margin: 0 !important;\n}\n\n@keyframes ax-spin { to { transform: rotate(360deg); } }\n@keyframes ax-pulse {\n  0%, 100% { transform: scale(0.8); opacity: 0.7; }\n  50% { transform: scale(1.15); opacity: 1; }\n}\n@keyframes ax-dot {\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n}\n@keyframes ax-fade-in { from { opacity: 0; } to { opacity: 1; } }\n\n@media (prefers-reduced-motion: reduce) {\n  .ax-spinner__ring, .ax-spinner__core, .ax-loader__dots i { animation-duration: 3s; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
